import { BaseService } from 'shared/services/BaseService';
import { IRequestDepartmentTranscode } from '../types';

class RequestDepartmentLaboratoryService extends BaseService<IRequestDepartmentTranscode> {
  constructor() {
    super('req-deps-labs');
  }
  canDelete = true;
}

export const requestDepartmentLaboratoryService = new RequestDepartmentLaboratoryService();
